<template>
  <v-container grid-list-md>
    <v-layout v-if="isLoggedIn" text-xs-center text-md-center mb-4>
      <v-flex xs1 sm1 md2 lg3></v-flex>
      <v-flex xs10 sm12 md8 lg6>
        <h1>Welcome to Shadhin Admin Panel</h1>
        <!-- <pre>{{ indexData.applica[0] }}</pre> -->
      </v-flex>
      <v-flex xs1 sm1 md2 lg3></v-flex>
    </v-layout>
    <div v-if="isLoggedIn">
      <v-layout row wrap mb-2>
        <v-flex sm12>
          <v-alert v-model="reveSmsAlert" dismissible type="warning">
            Your
            <em>REVE SMS</em>
            balance is low. Current balance is: {{ reveSmsBalance }} Tk. Credit
            Limit is: {{ reveSmsCredit }} Tk. Please recharge now.
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-2>
        <v-flex md4>
          <v-card class="pa-3" height="100%">
            <apexchart
              type="pie"
              height="360"
              :options="chart.emi.options"
              :series="chart.emi.series"
            ></apexchart>
          </v-card>
        </v-flex>
        <v-flex md8>
          <v-card class="pa-3">
            <apexchart
              type="area"
              height="350"
              :options="chart.application.options"
              :series="chart.application.series"
            ></apexchart>
          </v-card>
        </v-flex>
        <v-flex sm12>
          <v-card class="pa-3">
            <apexchart
              type="bar"
              height="350"
              :options="chart.payment.options"
              :series="chart.payment.series"
            ></apexchart>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-4>
        <v-flex xs12 class="my-3">
          <h2 class="headline">Overview of Loan Applications</h2>
        </v-flex>
        <v-flex
          v-for="item in loanOverview"
          v-bind:key="item.key"
          d-flex
          xs6
          sm4
          md3
          lg2
        >
          <v-card color="indigo" dark class="pa-1">
            <v-card-title class="title">
              {{ item.title }}
            </v-card-title>
            <v-card-text class="display-2 text-xs-center">
              <v-icon x-large left class="bg-icon">
                {{ item.icon || "event" }}
              </v-icon>
              {{ item.value }}
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap mb-4>
        <v-flex xs12 class="my-3">
          <h2 class="headline">Overview of EMIs</h2>
        </v-flex>

        <v-flex
          v-for="(item, key) in emiOverview"
          :key="key"
          d-flex
          xs6
          sm4
          md3
          lg2
        >
          <v-card color="indigo" dark class="pa-1">
            <v-card-title class="title">
              {{ item.title }}
            </v-card-title>
            <v-card-text class="display-2 text-xs-center">
              {{ item.value }}
            </v-card-text>
            <v-icon x-large left class="bg-icon">
              {{ item.icon || "event" }}
            </v-icon>
          </v-card>
        </v-flex>
      </v-layout>

      <v-expansion-panel class="my-4">
        <v-expansion-panel-content>
          <template v-slot:header>
            <h2 class="display-1 py-3">Report Module</h2>
          </template>
          <v-card class="pa-4">
            <v-layout row wrap>
              <v-flex d-flex xs12 md6 lg4>
                <v-card color="indigo lighten-2" light>
                  <v-card-title class="title white--text">
                    Repayment Tracker
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="indexData.repayment_tracker"
                      hide-actions
                      :expand="true"
                      :loading="isLoading"
                      :disable-initial-sort="true"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.title }}</td>
                        <td class="text-xs-right">{{ props.item.value }}</td>
                        <!-- <td class="text-xs-right">{{props.item.percentage}}</td> -->
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex d-flex xs12 md6 lg4>
                <v-card color="indigo lighten-2" light>
                  <v-card-title class="title white--text">
                    Investor
                  </v-card-title>
                  <v-card-text>
                    <v-data-table
                      :headers="headers"
                      :items="indexData.investor"
                      hide-actions
                      :loading="isLoading"
                      :disable-initial-sort="true"
                      class="elevation-1"
                    >
                      <template v-slot:items="props">
                        <td>{{ props.item.title }}</td>
                        <td class="text-xs-right">{{ props.item.value }}</td>
                        <!-- <td class="text-xs-right">{{props.item.percentage}}</td> -->
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </div>
  </v-container>
</template>
<script>
  import { mapGetters } from "vuex";
  import VueApexCharts from "vue-apexcharts";
  import HTTP from "@/utils/HTTP";
  import { smsBalanceUrl } from "@/utils/variables";
  import Cookies from "js-cookie";

  export default {
    components: {
      apexchart: VueApexCharts,
    },

    data: () => ({
      info: null,
      // isLoading: false,
      headers: [
        { text: "Title", value: "title", sortable: false },
        { text: "Value", value: "value", align: "right" },
        // { text: '%', value: 'percentage', align: 'right' },
      ],

      reveSmsAlert: false,
      reveSmsBalance: 0,
      reveSmsCredit: 0,

      loanOverview: [
        // {
        //   title: "Applications",
        //   value: "9762",
        //   icon: "list_alt",
        //   link: "funding",
        // },
        // {
        //   title: "Pending",
        //   value: "0",
        //   icon: "pending_actions",
        // },
        // {
        //   title: "Approved",
        //   value: "7",
        //   icon: "fact_check",
        // },
        // {
        //   title: "Disbursed",
        //   value: "564",
        //   icon: "send",
        // },
        // {
        //   title: "Active",
        //   value: "253",
        //   icon: "directions_run",
        // },
        // {
        //   title: "Completed",
        //   value: "311",
        //   icon: "check_circle",
        // },
      ],

      emiOverview: [
        // {
        //   icon: "event",
        //   title: "Active EMIs",
        //   value: "737",
        // },
        // {
        //   icon: "event_busy",
        //   title: "Overdue",
        //   value: "603",
        // },
        // {
        //   icon: "event_available",
        //   title: "Paid",
        //   value: "1879",
        // },
      ],

      chart: {
        emi: {
          series: [],
          options: {
            title: {
              text: "EMI Overview",
            },
            noData: {
              text: "No data available",
            },
            chart: {
              type: "pie",
              toolbar: {
                show: true,
              },
            },
            labels: [],
            colors: [
              "#888888",
              "#71974c",
              "#00a0de",
              "#f9a01a",
              "#d34626",
              "#a9343a",
            ],
            legend: {
              show: true,
              position: "bottom",
            },
          },
        },
        application: {
          series: [], // Populated by API call
          options: {
            title: {
              text: "Applications vs Registrations",
            },
            noData: {
              text: "No data available",
            },
            chart: {
              type: "area",
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: "smooth",
            },
            xaxis: {
              type: "datetime",
              categories: [],
            },
          },
        },
        payment: {
          series: [],
          options: {
            title: {
              text: "Payment Overview",
            },
            noData: {
              text: "No data available",
            },
            chart: {
              type: "bar",
              toolbar: {
                show: true,
              },
            },
            xaxis: {
              categories: [],
            },
            yaxis: [
              {
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#008FFB",
                },
                labels: {
                  style: {
                    colors: "#008FFB",
                  },
                },
                title: {
                  text: "Number of transactions",
                  style: {
                    color: "#008FFB",
                  },
                },
                tooltip: {
                  enabled: true,
                },
              },
              {
                opposite: true,
                axisTicks: {
                  show: true,
                },
                axisBorder: {
                  show: true,
                  color: "#00E396",
                },
                labels: {
                  style: {
                    colors: "#00E396",
                  },
                },
                title: {
                  text: "Payment received (Tk)",
                  style: {
                    color: "#00E396",
                  },
                },
              },
            ],
            dataLabels: {
              enabled: false,
            },
          },
        },
      },
    }),

    created() {
      this.initialize();
      this.fetchReport();
      if (!Cookies.get("smsAlert")) {
        this.checkReveSmsBalance();
      }
    },

    computed: {
      ...mapGetters(["isLoggedIn", "indexData"]),

      isLoading: function () {
        return this.indexData.length == 0 ? true : false;
      },
    },

    watch: {
      reveSmsAlert() {
        if (this.reveSmsAlert == false) {
          Cookies.set("smsAlert", true, { expires: 1 });
        }
      },
    },

    methods: {
      initialize() {
        this.$store.dispatch("resetAll");
      },

      async fetchReport() {
        await this.$store.dispatch("setIndexData", ["report"]);
        // await this.$store.dispatch("setIndexData", [
        //   "report?start_date=2022-01-01&end_date='2022-01-31'",
        // ]);
        this.updateCharts();
      },

      async updateCharts() {
        // EMI Overview PIE Chart
        this.chart.emi.options = {
          labels: this.indexData.emi_overview.labels,
        };

        // Pie Chart has animaion issue. If the new series contains
        // more items then the animation doesn't work. To fix it
        // we first set the series dammy data, wait 50ms, and then
        // set with actual data
        let fetched_emis = this.indexData.emi_overview.series;
        // let emi_series = this.chart.emi.series;

        this.chart.emi.series = [1].concat(Array(fetched_emis.length).fill(0));

        // setTimeout(
        //   function() {
        //     this.chart.emi.series = fetched_emis;
        //   }.bind(this),
        //   500
        // );

        setTimeout(() => {
          this.chart.emi.series = fetched_emis;
        }, 500);

        // Loan applications vs User registrations graph
        this.chart.application.series = this.indexData.userReg_loanApp.series;
        this.chart.application.options = {
          xaxis: {
            categories: this.indexData.userReg_loanApp.categories,
            type: "datetime",
          },
        };

        // Payment Overview graph
        this.chart.payment.series = this.indexData.payment_overview.series;
        this.chart.payment.options = {
          xaxis: {
            categories: this.indexData.payment_overview.categories,
            type: "datetime",
          },
        };

        // Overview of Loan Applications
        this.loanOverview = this.indexData.application_overview;

        // EMI Overview
        this.emiOverview = this.indexData.overview_emi_list;
      },

      async checkReveSmsBalance() {
        try {
          const response = await HTTP().get(smsBalanceUrl);
          if (response.data.data) {
            this.reveSmsBalance = response.data.data.Balance;
            this.reveSmsCredit = response.data.data.CreditLimit;
          }
          if (this.reveSmsBalance < 1000) {
            this.reveSmsAlert = true;
          }
        } catch (e) {
          false;
        }
      },
    },
  };
</script>
<style scoped>
  i.v-icon.bg-icon {
    position: absolute;
    opacity: 0.15;
    font-size: 75px !important;
    left: 15px;
    bottom: 15px;
  }

  body {
    background-color: #f1f1f1;
  }

  content {
    background-color: red !important;
  }

  .pa-3 {
    z-index: 0 !important;
  }
</style>
